import moment, { type Moment } from 'moment'
import { type ChangeEvent, useEffect, useState } from 'react'

import { onCheckDisabledConditions } from '@/app/utils'

interface IField {
    name: string
    value: string
    placeholder: string
    error: string | null
    isTouched: boolean
}

interface IDateField {
    name: string
    value: Moment
    placeholder: string
    error: string | null
    isTouched: boolean
}

export const useFields = () => {
    const initialFio = { name: 'fio', value: '', placeholder: 'Введите ФИО', error: null, isTouched: false }
    const initialDate = {
        name: 'date',
        value: moment(),
        placeholder: 'Введите дату',
        error: null,
        isTouched: false
    }
    const initialContent = {
        name: 'content',
        value: '',
        placeholder: 'Введите текст отзыва',
        error: null,
        isTouched: false
    }

    const [fio, setFio] = useState<IField>(initialFio)
    const [date, setDate] = useState<IDateField>(initialDate)
    const [content, setContent] = useState<IField>(initialContent)

    useEffect(() => {
        if (!fio.value.length) {
            setFio((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else {
            setFio((prev) => ({ ...prev, error: null }))
        }

        if (!date.value) {
            setDate((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else {
            setDate((prev) => ({ ...prev, error: null }))
        }

        if (!content.value.length) {
            setContent((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else {
            setContent((prev) => ({ ...prev, error: null }))
        }
    }, [fio.value, date.value, content.value])

    const onChangeFio = (e: ChangeEvent<HTMLInputElement>) => setFio((prev) => ({ ...prev, value: e.target.value }))
    const onChangeDate = (e: Moment) => setDate((prev) => ({ ...prev, value: e }))
    const onChangeContent = (e: ChangeEvent<HTMLTextAreaElement>) =>
        setContent((prev) => ({ ...prev, value: e.target.value }))

    const onTouchFio = () => setFio((prev) => ({ ...prev, isTouched: true }))
    const onTouchContent = () => setContent((prev) => ({ ...prev, isTouched: true }))

    const onZeroFio = () => setFio((prev) => ({ ...prev, value: '' }))
    const onZeroDate = () => setDate((prev) => ({ ...prev, value: moment() }))
    const onZeroContent = () => setContent((prev) => ({ ...prev, value: '' }))

    const isValidFields = onCheckDisabledConditions(
        Boolean(!fio.error),
        Boolean(fio.isTouched),
        Boolean(!date.error),
        Boolean(!content.error),
        Boolean(content.isTouched)
    )

    return {
        fio,
        onChangeFio,
        onTouchFio,
        onZeroFio,
        date,
        onChangeDate,
        onZeroDate,
        content,
        onChangeContent,
        onTouchContent,
        onZeroContent,
        isValidFields
    }
}
